<template>
  <OmtStickedModal v-if="isOpen" @close="$emit('close')">
    <OmtRow mb="16px">
      <OmtTypography as="h1-bold"> Documentos necessários </OmtTypography>
    </OmtRow>

    <CAccordion :defaultIndex="indexOpen" :allowToggle="true">
      <CAccordionItem v-for="(info, i) in necessaryDocs" :key="i">
        <CAccordionHeader
          px="0"
          v-bind="{
            _hover: {
              background: 'inherit'
            },
            _focus: {
              boxShadow: 'none'
            }
          }"
        >
          <CBox flex="1" text-align="left">
            <OmtTypography as="h3-semi-bold"> {{ info.title }} </OmtTypography>
          </CBox>
          <CAccordionIcon />
        </CAccordionHeader>

        <CAccordionPanel pb="0" pl="0">
          <OmtTypography pb="8px" as="p1"> <span v-html="info.text"></span></OmtTypography>

          <CBox p="0px">
            <CList v-if="info.list.length" styleType="disc" ml="-14px">
              <CBox w="100%" v-for="(item, listIndex) in info.list" :key="`info-${listIndex}`">
                <OmtTypography
                  as="p1"
                  v-for="(subItem, subItemIndex) in item.sublist"
                  :key="`subItem-${listIndex}-${subItemIndex}`"
                  :pb="subItemIndex === item.sublist.length - 1 ? '8px' : '0'"
                >
                  <CListItem mb="6px" v-if="typeof subItem === 'string'">
                    <span v-html="subItem"></span>
                  </CListItem>
                </OmtTypography>
              </CBox>
              <CBox w="100%" v-for="(most, mostIndex) in info.mostLists" :key="`most-${mostIndex}`">
                <OmtTypography as="p0" pb="16px" color="var(--colors-lightPrimary-gray2)">
                  {{ most.title }}
                </OmtTypography>
                <CBox v-for="(item, itemIndex) of most.list" :key="`most-${mostIndex}-${itemIndex}`">
                  <CFlex pb="16px">
                    <OmtIcons :name="item.icon" size="sm" mr="2" />
                    <OmtTypography as="p0">{{ item.subtitle }}</OmtTypography>
                  </CFlex>
                  <CBox>
                    <OmtTypography
                      as="p2"
                      v-for="(subItem, subItemIndex) in item.sublist"
                      :key="`most-${mostIndex}-${itemIndex}-${subItemIndex}`"
                      :pb="subItemIndex === item.sublist.length - 1 ? '16px' : '0'"
                    >
                      <CListItem mb="6px" v-if="typeof subItem === 'string'">
                        <span v-html="subItem"></span>
                      </CListItem>
                    </OmtTypography>
                  </CBox>
                </CBox>
              </CBox>
            </CList>
          </CBox>
          <CBox>
            <OmtRow>
              <OmtTypography v-if="info.outros" as="p1">
                Esses serviços devem ser acessados pelo menu lateral do app, de forma rápida e simples.</OmtTypography
              >
            </OmtRow>
            <OmtRow mt="8px">
              <OmtTypography v-if="info.outros" as="p1"
                ><omt-bold color="var(--colors-lightPrimary-gray2)">Precisa de ajuda?</omt-bold>
              </OmtTypography>
            </OmtRow>
          </CBox>

          <OmtRow>
            <OmtTypography v-if="info.outros" as="p1"
              >Fale com a nossa Central pelo 0800 726 4000 ou pelo
              <b class="whatsApp" @click="OpenwhatsApp">WhatsApp</b>
            </OmtTypography>
          </OmtRow>

          <CFlex
            backgroundColor="var(--colors-light-primary-light-gray)"
            borderRadius="8px"
            padding="16px"
            v-if="shouldShowAlert(info.title)"
          >
            <CBox>
              <OmtIcons name="circle-exclamation" size="lg" mr="2" color="var(--colors-light-support-warning)" />
            </CBox>
            <CBox>
              <OmtTypography as="p1" fontWeight="400" lineHeight="22px">
                <span v-html="info.alert"></span>
              </OmtTypography>
            </CBox>
          </CFlex>
        </CAccordionPanel>

        <CDivider mt="8px" />
      </CAccordionItem>
    </CAccordion>
  </OmtStickedModal>
</template>

<script>
import { isMobile } from "@/utils/utils";
export default {
  name: "DocumentsModal",
  props: {
    isOpen: {
      Type: Boolean
    },
    subjectOptions: {
      Type: Object
    },
    indexOpen: {
      type: Number,
      default: -1
    }
  },
  data() {
    return {
      necessaryDocs: []
    };
  },
  computed: {
    isMobile() {
      return isMobile();
    }
  },
  methods: {
    init() {
      let necessaryDocs = [];
      if (this.subjectOptions?.length) {
        necessaryDocs = this.subjectOptions.map(o => {
          const doc = {
            title: o.label,
            text: o.warningOrientation
              ? `<span style='color: var(--colors-light-support-error)'>${o.warningOrientation}</span><br> `
              : o.orientation,
            list: o.attchamentType?.length
              ? [
                  {
                    subtitle: o.attchamentType,
                    icon: "file-waveform",
                    sublist: (o.attchamentDsc ?? []).map(a => a.dsc)
                  }
                ]
              : [],
            alert: o.warningDays,
            outros: o.outros || false
          };
          return doc;
        });
      }
      this.necessaryDocs = necessaryDocs;
    },
    shouldShowAlert(title) {
      return title !== "Análise de Cobertura Médica" && title !== "Análise de Cobertura Odontológica";
    },
    OpenwhatsApp() {
      let link = "https://wa.me/5511999351140";
      if (this.isMobile) {
        window.location = `${link}?text=Ol%C3%A1`;
      } else {
        window.open(link, "_blank", "noopener,noreferrer");
      }
    }
  },
  watch: {
    subjectOptions: {
      immediate: true,
      handler() {
        this.init();
      }
    }
  }
};
</script>
<style scoped>
.whatsApp {
  color: var(--colors-light-primary-navy-blue);
  cursor: pointer;
}
</style>
